module.exports = __webpack_public_path__ + "media/images/pekarska-pudorys-2d533cc1.svg";